export default __webpack_public_path__ + "9b2943d72be7e517d78cb2817bc5d2cc.png";